import { Shield, AlertTriangle } from '@werkstatt/ui'

export default function CustomerTwoFactorTab() {
  return (
    <div className="wc-card wc-elev-sm" style={{ gap: 18 }}>
      <div>
        <h3 className="wc-card-title" style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
          <Shield size={18} />
          Zwei-Faktor-Authentifizierung
        </h3>
        <p className="wc-muted" style={{ fontSize: 13, margin: '4px 0 0' }}>
          Erhöhen Sie die Sicherheit Ihres Kontos mit einem zweiten Faktor
        </p>
      </div>

      <div className="wc-alert wc-alert-info" style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
        <AlertTriangle size={16} style={{ flexShrink: 0, marginTop: 2 }} />
        <div>
          <strong>Feature in Entwicklung</strong>
          <p style={{ margin: '4px 0 0' }}>
            Die Zwei-Faktor-Authentifizierung wird derzeit für die Portal-App entwickelt. Dieses Feature
            ermöglicht es Ihnen, Ihr Konto mit einem zusätzlichen Sicherheitsfaktor zu schützen.
          </p>
        </div>
      </div>

      <div style={{ fontSize: 13 }} className="wc-muted">
        <p style={{ color: 'var(--wc-text)', fontWeight: 500, marginBottom: 6 }}>Was ist 2FA?</p>
        <p>
          Die Zwei-Faktor-Authentifizierung (2FA) fügt eine zusätzliche Sicherheitsebene zu Ihrem Konto hinzu.
          Nach der Aktivierung benötigen Sie neben Ihrem Passwort auch einen zeitbasierten Code von Ihrer
          Authenticator-App.
        </p>

        <p style={{ color: 'var(--wc-text)', fontWeight: 500, margin: '14px 0 6px' }}>Geplante Funktionen:</p>
        <ul style={{ listStyle: 'disc outside', paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 4 }}>
          <li>QR-Code Einrichtung mit Authenticator-Apps</li>
          <li>Backup-Codes für Notfälle</li>
          <li>Optionale Aktivierung/Deaktivierung</li>
          <li>Kompatibel mit Google Authenticator, Authy, etc.</li>
        </ul>
      </div>
    </div>
  )
}
